// Switcher metadata for the Omni Command shell (EDNA-2005). Extracted from
// federation-entry.ts so the shell can build its icon rail from `meta` without
// pulling the whole Mail bundle into its initial chunk — federation-entry
// re-exports this, so the entry contract is unchanged.
export const meta = {
  id: "mail" as const,
  label: "Mail" as const,
  icon: "Mail" as const,
  basePath: "/mail" as const,
  contextCardSupport: ["thread", "contact"] as const,
} as const;
